// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merchantInfo {\n  width: 100%;\n}\n.merchantInfo__left {\n  width: 50%;\n}\n.merchantInfo__right {\n  width: 50%;\n}", ""]);
// Exports
module.exports = exports;
